export default __webpack_public_path__ + "static/media/profile-3.870b15db.jpg";